<template>
  <b-container v-bind="getCategories">
    <b-form-group class="{ 'form-group--error': $v.name.$error }" novalidate>
      <h4>Check availability</h4>
      <b-row no-gutters>
        <div class="col-12 col-sm-6 col-md-2 mt-2" v-if="categoryColumn">
          <b-row no-gutters>
            <div class="col-2 justify-content-end">
              <!-- <font-awesome-icon right size="lg" icon="sitemap" :style="{ color: '#6c757d'}" /> -->
            </div>
            <div class="col-10">
              <b-form-select v-model="categorySelected">
                <option value>Select a category</option>
                <option value="0">All</option>
                <option
                  v-for="item in getCategories"
                  :key="item.id"
                  :value="item.id"
                >{{ item.name | capitalize }}</option>
              </b-form-select>
              <!-- Category: {{ categorySelected }} -->
            </div>
          </b-row>
        </div>
        <div class="col-12 col-sm-6 col-md-2 mt-2">
          <b-row no-gutters>
            <div class="col-2 justify-content-end">
              <!-- <font-awesome-icon size="lg" icon="calendar-alt" :style="{ color: '#6c757d'}" /> -->
            </div>
            <div class="col-10">
              <datepicker placeholder="Arrival Date" v-model="from_date" format="dd-MMM-yyyy" />
            </div>
          </b-row>

          <!-- {{ from_date }} -->
        </div>
        <div class="col-12 col-sm-6 col-md-2 mt-2">
          <b-row no-gutters>
            <div class="col-2">
              <!-- <font-awesome-icon size="lg" icon="clock" :style="{ color: '#6c757d'}" /> -->
            </div>
            <div class="col-10">
              <!-- @input="setName($event.target.value)" -->
              <b-form-select v-model="days" placeholder="Length of stay">
                <option value="0">Length of stay</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </b-form-select>
              <!-- Days selected: {{ days }} -->
            </div>
          </b-row>
        </div>
        <div class="col-12 col-sm-6 col-md-2 mt-2">
          <b-row no-gutters>
            <div class="col-2">
              <!-- <font-awesome-icon size="lg" icon="users" :style="{ color: '#6c757d'}" /> -->
            </div>
            <div class="col-10">
              <b-dropdown id="dropdown-text" text="Party Members" class="md-2">
                <b-dropdown-text>
                  <b-row>
                    <div class="col-sm-4">Adult</div>
                    <div class="col-sm-8">
                      <b-form-input v-model="adultSelected" type="number"></b-form-input>
                    </div>
                  </b-row>
                  <b-row>
                    <div class="col-sm-4">Child</div>
                    <div class="col-sm-8">
                      <b-form-input v-model="childSelected" type="number"></b-form-input>
                    </div>
                  </b-row>
                </b-dropdown-text>
              </b-dropdown>
            </div>
          </b-row>
        </div>
       <b-col md="2" sm="12" class="mt-2">
          <b-button block @click="getSearchResults">
            <b-spinner class="spinner" v-show="spinner" medium label="Loading... "></b-spinner>Search
          </b-button>
        </b-col>
       
      </b-row>
    </b-form-group>
    <!-- Show results -->
    <div class="row" v-if="availabilityCheck">
      <div class="col">Unfortunately there is no availability for those dates please try again.</div>
    </div>
    <b-row class="searchRows" v-if="displayResults">
      <h3 class="col-12">We have found the following results:</h3>
      <div v-bind:key="item.id" v-for="item in searchResults" class="row searchResults">
        <div class="col-md-6">
          <div>
            <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="4000"
              controls
              indicators
              background="#ababab"
              img-width="600"
              img-height="500"
              style="text-shadow: 1px 1px 2px #333;"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <!-- v-if wrapper -->
              <div v-if="item.images !== 'data:image/jpeg;base64'" class="carousel">
                <!-- Text slides with image -->
                <b-carousel-slide v-for="(slide, index) in item.images" :key="slide">
                  <template v-slot:img>
                    <img
                      class="d-block img-fluid w-100"
                      width="1024"
                      height="480"
                      :src="`https://cdn.anytimebooking.io/unit/${item.unitId}-${index}.jpg`"
                      alt="image slot"
                      @error="imgUrlAlt($event)"
                    />
                  </template>
                </b-carousel-slide>
              </div>
            </b-carousel>
          </div>
        </div>
        <div class="col-md-6">
          <h4>{{ item.unit_name }}</h4>
          <p>{{ item.unit_description }}</p>
          <div v-if="item.amenities" class="row">
            <div class="col-4">
              <h5>Amenities</h5>
            </div>
            <div v-for="amenity in item.amenities" v-bind:key="amenity.id">
              <div class="col-md-2">
                <font-awesome-icon
                  icon="hot-tub"
                  size="2x"
                  v-if="amenity === 1"
                  title="Hot Tub"
                  v-b-popover.hover.top="'Hot Tub'"
                />
                <font-awesome-icon
                  icon="dog"
                  size="2x"
                  v-if="amenity === 2"
                  title="Pet Friendly"
                  v-b-popover.hover.top="'Pet Friendly'"
                />
                <font-awesome-icon
                  icon="wifi"
                  size="2x"
                  v-if="amenity === 3"
                  title="Wifi available"
                  v-b-popover.hover.top="'Wifi available'"
                />
                <font-awesome-icon
                  icon="wheelchair"
                  size="2x"
                  v-if="amenity === 5"
                  title="Accessible"
                  v-b-popover.hover.top="'Accessible'"
                />
                <font-awesome-icon
                  icon="umbrella-beach"
                  size="2x"
                  v-if="amenity === 7"
                  title="Coastal"
                  v-b-popover.hover.top="'Coastal'"
                />
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-6">
              <p>From: &pound;{{ item.price | formatPrice }}</p>
            </div>
            <div class="col-6">
              <a :href="item.deep_link">
                <b-button class="btn-lg">Book now</b-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <!-- Modal Component -->
    <b-modal id="modal1" v-model="modalShow" title="Choose an arrival date">
      <p class="my-4">{{ modalMessage }}</p>
    </b-modal>
  </b-container>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { required, between } from "vuelidate/lib/validators";
// const _ = require("lodash");
export default {
  data() {
    return {
      imageIterator: 1,
      checked: false,
      slide: 0,
      sliding: null,
      availabilityCheck: false,
      type: "number",
      from_date: "2020-08-01",
      categorySelected: 0,
      units: [],
      categories: [],
      days: 3,
      categoryColumn: true,
      party: 0,
      searchResults: [],
      displayResults: false,
      noResults: false,
      spinner: false,
      presetUrl: "",
      adultSelected: 2,
      childSelected: 0,
      categoryInput: "",
      arrivalInput: "",
      modalShow: false,
      modalMessage: "Please select an arrival date"
    };
  },
  validations: {
    categoryInput: {
      required,
      minLength: between(1, 10000)
    },
    daysInput: {
      between: between(1, 30)
    }
  },
  components: {
    Datepicker
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  computed: {
    getCategories() {
      return this.$store.getters.categories;
    }
  },
  methods: {
    imgUrlAlt(event) {
      event.target.src =
        "https://thelaurelsholidaypark.co.uk/wp-content/uploads/2018/10/beach-scene.jpg";
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    getSearchResults() {
      this.spinner = !this.spinner;

      if (this.from_date == "" || this.to_date == "") {
        this.modalShow = true;
      } else if (this.from_date > this.to_date) {
        this.modalMessage = 'Your "from date" is after your "to date" ';
        this.modalShow = true;
      } else {
        //resets the css for the no results div to display:none
        document.getElementById("vue-no-results").className = "resultsDisplay";

        // set the from and to date in moment
        let formattedFrom = moment(this.from_date).format("YYYY-MM-DD");
        let formattedTo = moment(this.from_date)
          .add(this.days, "days")
          // handles the departure date (which you don't want availability for)
          .subtract(1, "days")
          .format("YYYY-MM-DD");

        //TODO: this handles close match rate bands
        let ratesFormattedFrom = moment(this.from_date)
          .add(this.days, "days")
          .subtract(28, "days")
          .format("YYYY-MM-DD");
        // get availability by the dates set
        let availabilitiesResult = this.$store.getters.availability(
          formattedFrom,
          formattedTo,
          this.categorySelected
        );
        console.log(availabilitiesResult);
        // get unit by the category set
        if (availabilitiesResult.length > 0) {
          // console.log(availabilitiesResult);
          // Getters
          let units = this.$store.getters.units(this.categorySelected);
          console.log(units);
          let rates = this.$store.getters.rates(
            ratesFormattedFrom,
            formattedTo
          );
          // // TODO: pass in an array of amenity ids
          // let amenities = this.$store.getters.amenityFiltered(
          //   this.amenitySelected
          // );

          // init search results
          // the following resets the search results array to blank
          this.searchResults = [];
          //used in locally in this method which is then passed back to this.searchResults
          let thisSearchResults = [];

          // work out party size and party breakdown (adults + children)
          // assigned to variables as this does not work in nested loops
          let adultParty = this.adultSelected;
          let childParty = this.childSelected;
          let totalParty = adultParty + childParty;
          let lengthOfStay = this.days;
          let unitPrice = this.calculatePrice;
          console.log(units);
          units.forEach(function(item1) {
            // Build deeplink url
            let rawUrl = item1.deeplinkUrl;
            let urlArray = rawUrl.split("[");
            let firstSplit = urlArray[0];
            let presetUrl =
              firstSplit +
              formattedFrom +
              "/" +
              lengthOfStay +
              "/0/" +
              totalParty +
              "/0/0/" +
              adultParty +
              "/" +
              childParty +
              "/";

            // check for availability and only display if true
            let availabilityOK = true;
            let availabilityDays = [];
            let thisLevel = 0;
            let availabilityUnitId = 0;
            let unitId = item1.id;
            let availabilityKey = "";
            if (item1.parent_id == 0) {
              // console.log('parent unit is zero')

              // if availability getter returns rows
              if (availabilitiesResult) {
                availabilitiesResult.forEach(function(item2) {
                  // reassigns availabilityUnitId to the unit id in each item2
                  availabilityUnitId = item2.unit_id;
                  if (availabilityUnitId == unitId) {
                    console.log(
                      "units with availability: " + availabilityUnitId
                    );
                    // set the key of availabilityDays as
                    availabilityKey = moment(item2.day).format("YYYY-MM-DD");
                    // and then set the value of availabilityDays
                    availabilityDays[availabilityKey] = item2.level;
                    console.log(availabilityDays);
                  }
                }); 
                // console.log(availabilityDays);

                // puts formattedFrom back to full date object
                let startDate = moment(formattedFrom);

                // cant use foreach because length of stay is a number single item.

                let tempDate = startDate.format("YYYY-MM-DD");
                for (let i = 0; i < lengthOfStay; i++) {
                  let thisDaysAvailability = availabilityDays[tempDate];
                  // console.log(thisDaysAvailability);
                  if (typeof thisDaysAvailability == "undefined") {
                    availabilityOK = false;
                  } else {
                    console.log("index position");
                    console.log(i);
                    if (i == 0) {
                      thisLevel = parseInt(thisDaysAvailability);
                    } else if (parseInt(thisDaysAvailability, 10) === 0) {
                      availabilityOK = false;
                    }
                  }
                  tempDate = moment(tempDate)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  // console.log(tempDate);
                }
              } else {
                availabilityOK = false;
              }



              // if days in the range selected all have at least level 1 then move on to setting rates
              if (availabilityOK) {
                // console.log("availability ok");
                // for price raw prices, arrival date and length of stay
                let thisPrice = unitPrice(
                  rates,
                  unitId,
                  formattedFrom,
                  lengthOfStay
                );

                
                let searchResultItem = {};
                // the following shows results if amenities filter has been selected
                
                  searchResultItem = {
                    unitId: item1.id,
                    unit_name: item1.name,
                    unit_description: item1.description,
                    day: formattedFrom,
                    level: thisLevel,
                    thumbnail: "AB-white-logo.png",
                    deep_link: presetUrl,
                    price: thisPrice,
                    images: {
                      1:
                        "https://cdn.anytimebooking.io/unit/" +
                        unitId +
                        "-1.jpg",
                      2:
                        "https://cdn.anytimebooking.io/unit/" +
                        unitId +
                        "-2.jpg",
                      3:
                        "https://cdn.anytimebooking.io/unit/" +
                        unitId +
                        "-3.jpg",
                      4:
                        "https://cdn.anytimebooking.io/unit/" +
                        unitId +
                        "-4.jpg"
                    }
                  };

                  thisSearchResults.push(searchResultItem);
                }
              
            }
          });

          if (thisSearchResults.length > 0) {
            this.searchResults = thisSearchResults;
            this.availabilityCheck = false;
            this.displayResults = true;
          } else {
            document.getElementById("vue-no-results").className =
              "showNoResults";
          }
          this.spinner = !this.spinner;
        } else {
          this.spinner = !this.spinner;
          this.availabilityCheck = true;
          this.displayResults = false;
          console.log("no availability");
        }
      }
    },
    calculatePrice(rates, unit, arrivalDate, lengthOfStay) {
      console.log(rates)
      let totalRate = 0;
      if (rates.length > 0) {
        rates.forEach(function(item) {
          // unit is unit id
          if (item.unit_id == unit) {
            if (item.price_type == 1) {
              // daily
              //let startDate = moment(item.day);
              //let endDate = moment(item.day2);
              //let thisDuration = item.duration;

              // TODO: work out rates for every day in search criteria
              //let thisDate = startDate.format("YYYY-MM-DD");
              //while (startDate <= endDate) {
              // let firstIndex = (dailyRates[thisDate] = []);
              // let secondIndex = (firstIndex[thisDuration] = item.rate);
              //startDate.add(1, "days");
              //thisDate = startDate.format("YYYY-MM-DD");
              //}

              // work out actual price for the length of stay
              totalRate = 0;
              let tempDate = moment(arrivalDate);
              let thisDate = tempDate.format("YYYY-MM-DD");
              for (let i = 0; i < lengthOfStay; i++) {
                var rateKey = rates[thisDate];
                if (typeof rateKey !== "undefined") {
                  let rateValue = rates[thisDate][1];
                  totalRate += parseFloat(rateValue);
                }
                tempDate.add(1, "days");
                thisDate = tempDate.format("YYYY-MM-DD");
              }
            } else if (item.price_type == 2) {
              // weekly
              // console.log("found weekly rates");
              totalRate = 0;
              //} else if (item.price_type == 3) {
              // short breaks
              //console.log('found short breaks rates')
              //totalRate = 0
            }
          }
        });
      } else {
        totalRate = 0;
        // console.log("there are no rates");
      }
      return totalRate;
    }
  }
};
</script>

<style lang="scss" scoped>
.searchResults {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 20px;
}
.searchResults {
  background: #bac1c745;
}

.searchResults:nth-child(2) {
  background: #6c757d45;
}
.resultsDisplay {
  display: none;
}

svg:not(:root).svg-inline--fa {
  overflow: visible;
}
.svg-inline--fa.fa-w-16 {
  width: 1em;
}
.svg-inline--fa {
  margin-right: 3px;
  padding-top: 3px;
  margin-top: 5px;
  float: right;
  color: green;
}

.showNoResults {
  display: inline;
}

input,
select {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  width: 100%;
}
.vdp-datepicker {
  input {
    padding: 5px;
    font-size: 0.75rem;
  }
}
.svg-inline--fa {
  margin-right: 3px;
  padding-top: 3px;
  margin-top: 5px;
  float: right;
}

.custom-select {
  font-size: 0.75rem;
}
.btn {
  font-size: 0.75rem;
}
</style>